// import React from "react";
// import { TableContainer, Table, Thead, Tbody, Tr, Th, Td, Box, Text, Button } from "@chakra-ui/react";

// import jsPDF from 'jspdf';
// import autoTable from "jspdf-autotable";

// function somarArray(array) {
//   var soma = 0;
//   for (var elemento of array) {
//     soma += elemento;
//   }
//   return soma;
// }


// function TabelaFinanceira({ dados }) {

//   // const [detalhesModal, setDetalhesModal] = useState([]);
//   // const [isOpen, setIsOpen] = useState(false);

//   // console.log(dados)

//   const gruposDRE = [...new Set(dados.map((dado) => dado.GrupoDRE))];

//   const totalgeraltrue = [];
//   const totalgeralfalse = [];
//   // console.log(gruposDRE)

//   const gruposTrue = gruposDRE.filter((grupo) => dados.some((dado) => dado.GrupoDRE === grupo && dado.Despesa));
//   const gruposFalse = gruposDRE.filter((grupo) => dados.some((dado) => dado.GrupoDRE === grupo && !dado.Despesa));


//   // const gruposTrue = gruposDRE.filter((grupo) => grupo);
//   // const gruposFalse = gruposDRE.filter((grupo) => !grupo);

//   const meses = [
//     "Janeiro",
//     "Fevereiro",
//     "Março",
//     "Abril",
//     "Maio",
//     "Junho",
//     "Julho",
//     "Agosto",
//     "Setembro",
//     "Outubro",
//     "Novembro",
//     "Dezembro"
//   ];

//   const formatarValor = (valor) => {
//     const formatter = new Intl.NumberFormat('pt-BR', {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     });

//     return formatter.format(valor);
//   };

//   const gerarPDF = () => {
//     const doc = new jsPDF('landscape');
//     const margin = 10; // Define a margem entre os elementos

//     doc.setFontSize(12);
//     doc.text("Relatório de Plano de Contas", 10, 10);

//     // Cabeçalhos da tabela
//     const header = ["Grupo DRE", "Plano de Conta", ...meses, "Total Ano"];
//     const columns = ["", "", ...meses, "Total Ano"];

//     // Dados para Receitas e Despesas
//     const receitas = [];
//     const despesas = [];

//     // Processamento de Receitas
//     const totalgeraltrue = new Array(meses.length).fill(0);
//     gruposFalse.forEach((grupo) => {
//       if (grupo !== "") {
//         receitas.push([{ content: grupo || "Não Agrupado", colSpan: header.length, styles: { halign: 'left', fillColor: "white", textColor: "blue" } }]);
//         const filteredDados = dados.filter((dado) => {
//           if (grupo === "" || grupo === null) {
//             return (!dado.GrupoDRE || dado.GrupoDRE === "") && !dado.Despesa;
//           } else {
//             return dado.GrupoDRE === grupo && !dado.Despesa;
//           }
//         });

//         let totalValues = new Array(meses.length).fill(0);
//         filteredDados.forEach((dado) => {
//           totalValues = new Array(meses.length).fill(0); // Zerando todos os campos
//           dado.Meses.forEach((mes) => {
//             const value = mes.ValorTotalPago.ValorTotalPago || 0;
//             totalValues[mes.Mes - 1] += value;
//             totalgeraltrue[mes.Mes - 1] += value;
//           });
//           receitas.push([
//             "", dado.PlanoDeConta, ...totalValues.map(formatarValor), formatarValor(somarArray(totalValues))
//           ]);
//         });

//         receitas.push([
//           "", "Total", ...totalgeraltrue.map(formatarValor), formatarValor(somarArray(totalgeraltrue))
//         ]);
//       }
//     });

//     // Processamento de Despesas
//     const totalgeralfalse = new Array(meses.length).fill(0);
//     gruposTrue.forEach((grupo) => {
//       if (grupo !== "") {
//         despesas.push([{ content: grupo || "Não Agrupado", colSpan: header.length, styles: { halign: 'left', fillColor: "white", textColor: "red" } }]);
//         const filteredDados = dados.filter((dado) => {
//           if (grupo === "" || grupo === null) {
//             return (!dado.GrupoDRE || dado.GrupoDRE === "") && dado.Despesa;
//           } else {
//             return dado.GrupoDRE === grupo && dado.Despesa;
//           }
//         });

//         let totalValues = new Array(meses.length).fill(0); // Zerando todos os campos
//         filteredDados.forEach((dado) => {
//           totalValues = new Array(meses.length).fill(0);
//           dado.Meses.forEach((mes) => {
//             const value = mes.ValorTotalPago.ValorTotalPago || 0;
//             totalValues[mes.Mes - 1] += value;
//             totalgeralfalse[mes.Mes - 1] += value;
//           });
//           despesas.push([
//             "", dado.PlanoDeConta, ...totalValues.map(formatarValor), formatarValor(somarArray(totalValues))
//           ]);
//         });

//         despesas.push([
//           "", "Total", ...totalgeralfalse.map(formatarValor), formatarValor(somarArray(totalgeralfalse))
//         ]);
//       }
//     });

//     // Cálculo do Resultado e Total Ano
//     const resultado = meses.map((_, index) => formatarValor((totalgeraltrue[index] || 0) - (totalgeralfalse[index] || 0)));
//     const totalAnoResultado = formatarValor(somarArray(totalgeraltrue) - somarArray(totalgeralfalse));

//     let startY = 20; // Define a posição Y inicial para o primeiro elemento

//     // Adiciona legenda "Receitas(+)" em azul antes da tabela de receitas
//     doc.setTextColor(0, 0, 255); // Azul
//     doc.text("Receitas(+)", 10, startY);
//     startY += margin; // Atualiza a posição Y para o próximo elemento

//     // Renderiza a tabela de receitas
//     autoTable(doc, {
//       head: [header],
//       body: receitas,
//       startY: startY,
//       theme: 'grid',
//       styles: { fontSize: 9 }
//     });

//     startY = doc.autoTable.previous.finalY + margin; // Atualiza a posição Y para o próximo elemento

//     // Adiciona legenda "Despesas(-)" em vermelho antes da tabela de despesas
//     doc.setTextColor(255, 0, 0); // Vermelho
//     doc.text("Despesas(-)", 10, startY);
//     startY += margin; // Atualiza a posição Y para o próximo elemento

//     // Renderiza a tabela de despesas
//     autoTable(doc, {
//       head: [header],
//       body: despesas,
//       startY: startY,
//       theme: 'grid',
//       styles: { fontSize: 9 }
//     });

//     startY = doc.autoTable.previous.finalY + margin; // Atualiza a posição Y para o próximo elemento

//     const data = [];
//     const resultBalance = totalgeralfalse.map((value, index) => {
//       const receita = totalgeraltrue[index] !== undefined ? totalgeraltrue[index] : 0; // Se não existir, usa 0
//       const despesa = value || 0; // Se não existir, usa 0
//       const balance = receita - despesa;
//       return formatarValor(balance); // Exibe o valor negativo se for o caso
//     });

//     data.push([
//       "Resultado Balanço:",
//       "",
//       ...resultBalance,
//       formatarValor(somarArray(totalgeraltrue) - somarArray(totalgeralfalse))
//     ]);

//     // Renderiza a tabela de resultado do balanço
//     autoTable(doc, {
//       head: [columns],
//       body: data,
//       styles: { fontSize: 8 },
//       margin: { top: 10, left: 10, right: 10, bottom: 10 },
//       pageBreak: 'auto',
//       startY: startY
//     });

//     // Salva o PDF
//     doc.save("tabela_financeira.pdf");
//   };


//   return (
//     <>
//       <Text mb={1} fontSize={{ base: 'sm', md: 'md', lg: 'lg' }} color={'blue'}>(+) Receitas</Text>
//       <Table variant="striped" w='100%' size="sm" maxWidth="100%">
//         {/* Tabela para grupos True */}
//         <Thead>
//           <Tr>
//             <Th textAlign="center" bg={'#5e9ff2'} textColor={'#FFFFFF'} borderWidth="1px" borderColor="black">Grupo DRE</Th>
//             <Th textAlign="center" bg={'#5e9ff2'} textColor={'#FFFFFF'} borderWidth="1px" borderColor="black">Plano de Conta</Th>
//             {meses.map((mes, index) => (
//               <Th textAlign="center" bg={'#5e9ff2'} textColor={'#FFFFFF'} borderWidth="1px" borderColor="black" key={index}>{mes}</Th>
//             ))}
//             <Th textAlign="center" bg={'#5e9ff2'} textColor={'#FFFFFF'} borderWidth="1px" borderColor="black">Total Ano</Th>
//           </Tr>
//         </Thead>
//         <Tbody>
//           {gruposFalse.map((grupo) => {
//             // const filteredDados = dados.filter((dado) => dado.GrupoDRE === grupo && dado.Despesa);
//             // const filteredDados = dados.filter((dado) => (dado.GrupoDRE === grupo || (!dado.GrupoDRE && grupo === "")) && !dado.Despesa);
//             const filteredDados = dados.filter((dado) => {
//               if (grupo === "" || grupo === null) {
//                 return (!dado.GrupoDRE || dado.GrupoDRE === "") && !dado.Despesa;
//               } else {
//                 return dado.GrupoDRE === grupo && !dado.Despesa;
//               }
//             });
//             const totalValues = meses.map(() => 0);

//             return (
//               grupo !== "" && (
//                 <React.Fragment key={grupo}>
//                   <Tr>
//                     <Td colSpan={15}>
//                       <Text fontWeight="bold">{grupo || "Não Agrupado"}</Text>
//                     </Td>
//                   </Tr>
//                   {filteredDados.map((dado) => {
//                     const mesValues = dado.Meses.map((mes) => {
//                       const value = mes.ValorTotalPago.ValorTotalPago || 0;
//                       totalValues[mes.Mes - 1] += value;
//                       if (totalgeraltrue[mes.Mes - 1]) {
//                         totalgeraltrue[mes.Mes - 1] += value;
//                       } else {
//                         totalgeraltrue[mes.Mes - 1] = value;
//                       }

//                       // console.log(totalValues)
//                       // console.log(totalgeraltrue)
//                       return value;
//                     });

//                     return (
//                       <Tr key={dado.PlanoDeConta}>
//                         <Td></Td>
//                         <Td>{dado.PlanoDeConta}</Td>
//                         {mesValues.map((value, valueIndex) => (
//                           <Td key={valueIndex}>{formatarValor(value)}</Td>
//                         ))}
//                         {/* <Td width="5%"></Td>
//                         <Td width="35%">{dado.PlanoDeConta}</Td>
//                         {mesValues.map((value, valueIndex) => (
//                           <Td width="6%" key={valueIndex}>{formatarValor(value)}</Td>
//                         ))} */}
//                         <Td>{formatarValor(somarArray(mesValues))}</Td>
//                       </Tr>
//                     );
//                   })}
//                   <Tr>
//                     <Td></Td>
//                     <Td><Text fontWeight="bold">Total</Text></Td>
//                     {totalValues.map((value, valueIndex) => (
//                       <Td key={valueIndex}><Text fontWeight="bold">{formatarValor(value)}</Text></Td>
//                     ))}
//                     <Td><Text fontWeight="bold">{formatarValor(somarArray(totalValues))}</Text></Td>
//                   </Tr>
//                 </React.Fragment>
//               )
//             );
//           })}
//         </Tbody>
//         {/* </Table> */}
//         <Text mt={4} mb={1} fontSize={{ base: 'sm', md: 'md', lg: 'lg' }} color={'red'}>(-) Despesa</Text>
//         {/* <Table variant="striped" w='100%' size="sm" maxWidth="100%"> */}

//         {/* Tabela para grupos False */}
//         {/* <Thead>
//           <Tr>
//             <Th textAlign="center" bg={'#5e9ff2'} textColor={'#FFFFFF'} borderWidth="1px" borderColor="black">Grupo DRE</Th>
//             <Th textAlign="center" bg={'#5e9ff2'} textColor={'#FFFFFF'} borderWidth="1px" borderColor="black">Plano de Conta</Th>
//             {meses.map((mes, index) => (
//               <Th textAlign="center" bg={'#5e9ff2'} textColor={'#FFFFFF'} borderWidth="1px" borderColor="black" key={index}>{mes}</Th>
//             ))}
//           </Tr>
//         </Thead> */}
//         <Tbody>
//           {gruposTrue.map((grupo) => {

//             // const filteredDados = dados.filter((dado) => (dado.GrupoDRE === grupo || (!dado.GrupoDRE && grupo === "")) && dado.Despesa);
//             // const filteredDados = dados.filter((dado) => (dado.GrupoDRE === grupo || (dado.GrupoDRE === null && grupo === "")) && dado.Despesa);
//             const filteredDados = dados.filter((dado) => {
//               if (grupo === "" || grupo === null) {
//                 return (!dado.GrupoDRE || dado.GrupoDRE === "") && dado.Despesa;
//               } else {
//                 return dado.GrupoDRE === grupo && dado.Despesa;
//               }
//             });
//             const totalValues = meses.map(() => 0);

//             return (
//               grupo !== "" && (
//                 <React.Fragment key={grupo}>
//                   <Tr>
//                     <Td colSpan={15}>
//                       <Text fontWeight="bold">{grupo || "Não Agrupado"}</Text>
//                     </Td>
//                   </Tr>
//                   {filteredDados.map((dado) => {
//                     const mesValues = dado.Meses.map((mes) => {
//                       const value = mes.ValorTotalPago.ValorTotalPago || 0;
//                       totalValues[mes.Mes - 1] += value;
//                       // totalgeralfalse[mes.Mes - 1] += value;
//                       if (totalgeralfalse[mes.Mes - 1]) {
//                         totalgeralfalse[mes.Mes - 1] += value;
//                       } else {
//                         totalgeralfalse[mes.Mes - 1] = value;
//                       }

//                       return value;
//                     });

//                     return (
//                       <Tr key={dado.PlanoDeConta}>
//                         {/* <Td></Td>
//                         <Td>{dado.PlanoDeConta}</Td>
//                         {mesValues.map((value, valueIndex) => (
//                           <Td key={valueIndex}>{formatarValor(value)}</Td>
//                         ))} */}
//                         <Td width="5%"></Td>
//                         <Td width="10%">{dado.PlanoDeConta}</Td>
//                         {mesValues.map((value, valueIndex) => (
//                           <Td width="7%" key={valueIndex}>{formatarValor(value)}</Td>
//                         ))}
//                         <Td>{formatarValor(somarArray(mesValues))}</Td>
//                       </Tr>
//                     );
//                   })}
//                   <Tr>
//                     <Td></Td>
//                     <Td><Text fontWeight="bold">Total</Text></Td>
//                     {totalValues.map((value, valueIndex) => (
//                       <Td key={valueIndex}><Text fontWeight="bold">{formatarValor(value)}</Text></Td>
//                     ))}
//                     <Td><Text fontWeight="bold">{formatarValor(somarArray(totalValues))}</Text></Td>
//                   </Tr>
//                 </React.Fragment>
//               )
//             );
//           })}
//         </Tbody>
//         <Text mt={3} fontWeight="bold" fontSize={{ base: 'sm', md: 'md', lg: 'lg' }} >Resultado Balanço:</Text>
//         <Tbody>
//           <Tr>
//             <Td></Td>
//             <Td><Text fontWeight="bold">Total</Text></Td>
//             {/* {(() => {
//               console.log(totalgeralfalse, totalgeraltrue)
//               const elementosTd = [];
//               for (let i = 0; i < totalgeralfalse.length; i++) {
//                 const diferencaSubtraida = totalgeraltrue[i] - totalgeralfalse[i];
//                 elementosTd.push(
//                   <Td key={i}>
//                     <Text fontWeight="bold">{formatarValor(diferencaSubtraida)}</Text>
//                   </Td>
//                 );
//               }
//               return elementosTd;
//             })()} */}
//             {(() => {
//               console.log(totalgeralfalse, totalgeraltrue);
//               const elementosTd = [];

//               for (let i = 0; i < totalgeralfalse.length; i++) {
//                 const receita = totalgeraltrue[i] !== undefined ? totalgeraltrue[i] : 0; // Usa 0 se não existir
//                 const despesa = totalgeralfalse[i] || 0; // Usa 0 se não existir
//                 const diferencaSubtraida = receita - despesa;

//                 elementosTd.push(
//                   <Td key={i}>
//                     <Text fontWeight="bold">{formatarValor(diferencaSubtraida)}</Text>
//                   </Td>
//                 );
//               }

//               return elementosTd;
//             })()}
//             <Td><Text fontWeight="bold">{formatarValor(somarArray(totalgeraltrue) - somarArray(totalgeralfalse))}</Text></Td>
//           </Tr>
//         </Tbody>
//       </Table>
//       <Button onClick={gerarPDF} colorScheme="blue" mb={4}>
//         Gerar PDF
//       </Button>
//     </>
//   );
// }

// export default TabelaFinanceira;

import React, { useState } from "react";
import {
  TableContainer, Table, Thead, Tbody, Tr, Th, Td, Tfoot,
  Box, Text, Button, Modal, ModalOverlay, ModalContent,
  ModalHeader, ModalCloseButton, ModalBody, useDisclosure
} from "@chakra-ui/react";
import jsPDF from 'jspdf';
import autoTable from "jspdf-autotable";
import api from 'contexts/api'; // ou o caminho correto da sua instância

function somarArray(array) {
  return array.reduce((acc, val) => acc + val, 0);
}

function TabelaFinanceira({ dados, filtros }) {
  const [detalhesModal, setDetalhesModal] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const totalModal = detalhesModal.reduce((acc, item) => {
    const valor = item.Entrada || item.Saida || item.ValorPago || 0;
    return acc + valor;
  }, 0);

  const meses = [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
  ];

  const totalgeraltrue = [];
  const totalgeralfalse = [];

  console.log(dados)

  // const gruposDRE = [...new Set(dados.map((dado) => dado.GrupoDRE))];
  const gruposDRE = [...new Set(dados.map((dado) => (dado.GrupoDRE ?? "").trim()))];
  // const gruposTrue = gruposDRE.filter((grupo) => dados.some((dado) => dado.GrupoDRE === grupo && dado.Despesa));
  // const gruposFalse = gruposDRE.filter((grupo) => dados.some((dado) => dado.GrupoDRE === grupo && !dado.Despesa));

  const gruposTrue = gruposDRE.filter((grupo) =>
    dados.some((dado) => ((dado.GrupoDRE ?? "").trim()) === grupo && dado.Despesa)
  );

  const gruposFalse = gruposDRE.filter((grupo) =>
    dados.some((dado) => ((dado.GrupoDRE ?? "").trim()) === grupo && !dado.Despesa)
  );


  console.log(gruposDRE, gruposTrue, gruposFalse)

  const formatarValor = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(valor || 0);
  };

  const buscarDetalhes = async (params) => {
    try {
      const response = await api.get('/planodeconta/detalhe', { params });
      setDetalhesModal(response.data || []);
      onOpen();
    } catch (err) {
      console.error("Erro ao buscar detalhes:", err);
    }
  };


  return (
    <>
      <Text mb={1} fontSize={{ base: 'sm', md: 'md', lg: 'lg' }} color={'blue'}>(+) Receitas</Text>
      <Table variant="striped" w='100%' size="sm" maxWidth="100%">
        <Thead>
          <Tr>
            <Th textAlign="center" bg={'#5e9ff2'} textColor={'#FFFFFF'}>Grupo DRE</Th>
            <Th textAlign="center" bg={'#5e9ff2'} textColor={'#FFFFFF'}>Plano de Conta</Th>
            {meses.map((mes, i) => (
              <Th key={i} textAlign="center" bg={'#5e9ff2'} textColor={'#FFFFFF'}>{mes}</Th>
            ))}
            <Th textAlign="center" bg={'#5e9ff2'} textColor={'#FFFFFF'}>Total Ano</Th>
          </Tr>
        </Thead>
        <Tbody>
          {gruposFalse.map((grupo) => {
            const filtered = dados.filter(d => (grupo ? d.GrupoDRE === grupo : !d.GrupoDRE) && !d.Despesa);
            const totalValues = Array(meses.length).fill(0);

            return (
              <React.Fragment key={grupo}>
                <Tr>
                  <Td colSpan={15}><Text fontWeight="bold">{grupo || "Não Agrupado"}</Text></Td>
                </Tr>
                {filtered.map((dado, idx) => {
                  const mesValues = dado.Meses.map((mes, i) => {
                    const value = mes.ValorTotalPago?.ValorTotalPago || 0;
                    totalValues[i] += value;
                    totalgeraltrue[i] = (totalgeraltrue[i] || 0) + value;
                    return (
                      <Td
                        key={i}
                        cursor="pointer"
                        _hover={{ bg: "blue.200" }}
                        onClick={() => buscarDetalhes({
                          empresaID: dado.EmpresaID,
                          planoDeConta: dado.PlanoDeConta,
                          despesa: dado.Despesa,
                          mes: mes.Mes,
                          ano: filtros.ano,
                          tipoData: filtros.tipoData,
                          user: filtros.user
                        })}
                      >
                        {formatarValor(value)}
                      </Td>
                    );
                  });

                  return (
                    <Tr key={idx}>
                      <Td></Td>
                      <Td>{dado.PlanoDeConta}</Td>
                      {mesValues}
                      <Td>{formatarValor(somarArray(mesValues.map(td => parseFloat(td.props.children.replace(".", "").replace(",", ".")))))}</Td>
                    </Tr>
                  );
                })}
                <Tr>
                  <Td></Td>
                  <Td><Text fontWeight="bold">Total</Text></Td>
                  {totalValues.map((v, i) => (
                    <Td key={i}><Text fontWeight="bold">{formatarValor(v)}</Text></Td>
                  ))}
                  <Td><Text fontWeight="bold">{formatarValor(somarArray(totalValues))}</Text></Td>
                </Tr>
              </React.Fragment>
            );
          })}
        </Tbody>

        <Text mt={4} mb={1} fontSize={{ base: 'sm', md: 'md', lg: 'lg' }} color={'red'}>(-) Despesas</Text>
        <Tbody>
          {gruposTrue.map((grupo) => {
            const filtered = dados.filter(d => (grupo ? d.GrupoDRE === grupo : !d.GrupoDRE) && d.Despesa);
            const totalValues = Array(meses.length).fill(0);

            return (
              <React.Fragment key={grupo}>
                <Tr>
                  <Td colSpan={15}><Text fontWeight="bold">{grupo || "Não Agrupado"}</Text></Td>
                </Tr>
                {filtered.map((dado, idx) => {
                  const mesValues = dado.Meses.map((mes, i) => {
                    const value = mes.ValorTotalPago?.ValorTotalPago || 0;
                    totalValues[i] += value;
                    totalgeralfalse[i] = (totalgeralfalse[i] || 0) + value;
                    return (
                      <Td
                        key={i}
                        cursor="pointer"
                        // _hover={{ bg: "gray.100" }}
                        _hover={{ bg: "blue.200" }}
                        onClick={() => buscarDetalhes({
                          empresaID: dado.EmpresaID,
                          planoDeConta: dado.PlanoDeConta,
                          despesa: dado.Despesa,
                          mes: mes.Mes,
                          ano: filtros.ano,
                          tipoData: filtros.tipoData,
                          user: filtros.user
                        })}
                      >
                        {formatarValor(value)}
                      </Td>
                    );
                  });

                  return (
                    <Tr key={idx}>
                      <Td></Td>
                      <Td>{dado.PlanoDeConta}</Td>
                      {mesValues}
                      <Td>{formatarValor(somarArray(mesValues.map(td => parseFloat(td.props.children.replace(".", "").replace(",", ".")))))}</Td>
                    </Tr>
                  );
                })}
                <Tr>
                  <Td></Td>
                  <Td><Text fontWeight="bold">Total</Text></Td>
                  {totalValues.map((v, i) => (
                    <Td key={i}><Text fontWeight="bold">{formatarValor(v)}</Text></Td>
                  ))}
                  <Td><Text fontWeight="bold">{formatarValor(somarArray(totalValues))}</Text></Td>
                </Tr>
              </React.Fragment>
            );
          })}
        </Tbody>

        <Text mt={3} fontWeight="bold">Resultado Balanço:</Text>
        <Tbody>
          <Tr>
            <Td></Td>
            <Td><Text fontWeight="bold">Total</Text></Td>
            {meses.map((_, i) => {
              const receita = totalgeraltrue[i] || 0;
              const despesa = totalgeralfalse[i] || 0;
              return (
                <Td key={i}><Text fontWeight="bold">{formatarValor(receita - despesa)}</Text></Td>
              );
            })}
            <Td>
              <Text fontWeight="bold">
                {formatarValor(somarArray(totalgeraltrue) - somarArray(totalgeralfalse))}
              </Text>
            </Td>
          </Tr>
        </Tbody>
      </Table>

      {/* Modal para Detalhes */}


      <Modal isOpen={isOpen} onClose={onClose} size="5xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Lançamentos Detalhados</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Table size="sm" mt={4}>
              <Thead>
                <Tr>
                  <Th>Codigo</Th>
                  <Td>Cliente/Fornecedor</Td>
                  <Td>Banco</Td>
                  <Td>Centro de Custo</Td>
                  <Td>Plano de Conta</Td>
                  <Td>Numero do Documento</Td>
                  <Th>Data Vencimento</Th>
                  <Th>Data Competencia</Th>
                  <Th>Valor</Th>
                </Tr>
              </Thead>
              <Tbody>
                {detalhesModal.map((item, i) => (
                  <Tr key={i}>
                    <Td>{item.CodigoSequencial}</Td>
                    <Td>{item.Cliente}</Td>
                    <Td>{item.Banco}</Td>
                    <Td>{item.CentroDeCusto}</Td>
                    <Td>{item.PlanoDeConta}</Td>
                    <Td>{item.NumeroDocumento}</Td>
                    <Td>{new Date(item.DataCompetencia).toLocaleDateString()}</Td>
                    <Td>{new Date(item.DataCompetencia).toLocaleDateString()}</Td>
                    {/* <Td>{new Date(item[filtros.tipoData ? filtros.tipoData : 'DataCompetencia']).toLocaleDateString()}</Td> */}
                    <Td>{formatarValor(item.Entrada || item.Saida || item.ValorPago)}</Td>
                  </Tr>
                ))}
              </Tbody>
              <Tfoot>
                <Tr>
                  <Td colSpan="3" style={{ textAlign: 'right', fontWeight: 'bold' }}>Total:</Td>
                  <Td style={{ fontWeight: 'bold' }}>{formatarValor(totalModal)}</Td>
                </Tr>
              </Tfoot>
            </Table>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default TabelaFinanceira;
